import React from "react"
import PropTypes from "prop-types"
import Card from "../instances/Card"
import Intro from "../common/Intro"
import Media from "../instances/Media"
import Person from "../instances/Person"
import Spotlight from "../instances/Spotlight"
import SmartColour from "../../utils/ColourHandler"
import SmartPadding from "../../utils/PaddingHandler"
import Text from "../instances/Text"
import Project from "../instances/Project"
import Fact from "../instances/Fact"
import OTLink from "../common/otLink"
import { Swiper, SwiperSlide } from "swiper/react"
import {
  Controller,
  Thumbs,
  Navigation,
  Pagination,
  Mousewheel,
  Keyboard,
} from "swiper/modules"

/********************************
<Related />
/********************************
Version: 1.2
Created: 12 08 2023
Updated: 04 12 2025
Author: Richy Pears
/********************************
A generic use section for displaying
a number of instances in columns
which are controlled by Storyblok
/********************************/

const Related = ({ blok, theme, padding }) => {
  //  if (!blok) return null // Escape hatch
  const colour = SmartColour(theme)
  const paddingClasses = SmartPadding(padding)
  const columns = { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }
  const randomId =
    "brand_controller_wrapper_related_" + Math.floor(Math.random() * 100) + 1 // Random string created for unique ID

  return (
    <section
      className={`brand-section ${paddingClasses} ${
        colour.classes && colour.classes
      } px-0`}
    >
      <div className="container mx-auto px-0">
        <h1 className="mb-12 text-center">Other Things you might like</h1>

        <div className="aspect-auto brand-controller-wrapper" id={randomId}>
          <Swiper
            autoHeight={true}
            centeredSlides={false}
            centerInsufficientSlides={true}
            centeredSlidesBounds={true}
            grabCursor={true}
            loop={false}
            modules={[
              Thumbs,
              Navigation,
              Pagination,
              Mousewheel,
              Keyboard,
              Controller,
            ]}
            navigation={{
              prevEl: `#${randomId} .brand-controller-button-previous`,
              nextEl: `#${randomId} .brand-controller-button-next`,
            }}
            pagination={{
              el: `#${randomId} .brand-controller-pagination`,
              clickable: true,
              bulletElement: "li",
              bulletActiveClass: `brand-controller-pagination-bullet-active`,
              bulletClass: `brand-controller-pagination-bullet bg-${colour.text}`,
            }}
            slidesPerView={1.5}
            breakpoints={{
              580: {
                slidesPerView: 2.5,
              },
              640: {
                slidesPerView: 2.5,
              },
              768: {
                slidesPerView: 3.5,
              },
              1024: {
                slidesPerView: 3.5,
              },
              1280: {
                slidesPerView: 4.5,
              },
            }}
          >
            {blok &&
              blok.map((node, index) => {
                return (
                  <SwiperSlide className="self-stretch h-auto">
                    <Project node={node} theme="black" columns={columns} />
                  </SwiperSlide>
                )
              })}
          </Swiper>
          <span className="brand-controller-button brand-controller-button-previous material-icons left-4">
            chevron_left
          </span>
          <span className="brand-controller-button brand-controller-button-next material-icons right-4">
            chevron_right
          </span>
        </div>

        <div className="flex flex-row w-full items-center justify-center p-6 gap-6">
          <OTLink to="/things" button={true} colour="black" icon={true}>
            More things
          </OTLink>
          <OTLink
            to="/#contact"
            button={true}
            colour="black"
            icon="arrow_forward_ios"
          >
            Get in touch
          </OTLink>
        </div>
      </div>
    </section>
  )
}

export default Related

Related.defaultProps = {
  blok: null,
}

Related.propTypes = {
  blok: PropTypes.object,
}
